import React, { useState, useEffect, useRef } from 'react';
import './ConstructionBackground.css';

export const ConstructionBackground = ({ children }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [scrollY, setScrollY] = useState(0);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  // Parallax scroll effect
  useEffect(() => {
    const handleScroll = () => {
      if (sectionRef.current) {
        const rect = sectionRef.current.getBoundingClientRect();
        const scrollProgress = -rect.top / window.innerHeight;
        setScrollY(scrollProgress * 50);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div ref={sectionRef} className={`construction-bg-container ${isVisible ? 'visible' : ''}`}>
      {/* Parallax Background Image */}
      <div 
        className="construction-bg-image"
        style={{ transform: `translateY(${scrollY}px)` }}
      ></div>
      
      {/* Animated Overlay Elements */}
      <div className="construction-animations">
        {/* Subtle dust clouds */}
        <div className="dust-cloud dust-1"></div>
        <div className="dust-cloud dust-2"></div>
      </div>
      
      {/* Content Overlay */}
      <div className="construction-content">
        {children}
      </div>
    </div>
  );
};
